import { render, staticRenderFns } from "./narrative.vue?vue&type=template&id=13c7aac0"
import script from "./narrative.vue?vue&type=script&lang=js"
export * from "./narrative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports